import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyle } from "./style";
import { useDeviceType } from "@hook/useDeviceType";

interface IParams {
    description: string;
    onOpenModal(): void;
}

export const AddAddon = (props: IParams) => {
    const { description, onOpenModal } = props;
    const { classes } = useStyle({});
    const { t } = useTranslation("addons");
    const { isMobile } = useDeviceType();

    return (
        <div className={classes.centeredContainer}>
            <Button fullWidth={isMobile} variant="contained" onClick={() => onOpenModal()}>
                {t("getAddon", { description })}
            </Button>
        </div>
    );
};
